import api from './api';

export interface PainelChatToPay {
  periodo: { dias: number; desde: string; canal: string | null };
  sessoes: { total: number; whatsapp: number; simulador: number; com_carrinho: number; com_pago: number; escaladas: number; em_humano: number };
  mensagens: { recebidas: number; enviadas: number; erros_envio: number; pan_redigidos: number; intencoes_lyra: number; intencoes_regras: number };
  carrinhos: { total: number; abertos: number; confirmados: number; com_link: number; pagos: number; abandonados: number; cancelados: number; expirados: number; links_gerados: number; links_nao_pagos: number; confirmacoes_falhadas: number };
  dinheiro: { receita_cve: number; ticket_medio_cve: number | null };
  indicadores: { conversao_pct: number | null; abandono_checkout_pct: number | null; escalonamento_pct: number | null; tempo_mediano_min: number | null };
  servicos: { total: number; pagos: number; receita_cve: number; com_token: number };
  por_loja: Array<{ loja_id: string; loja: string; sessoes: number; carrinhos: number; pagos: number; receita_cve: number }>;
  por_dia: Array<{ dia: string; sessoes: number; pagos: number; receita_cve: number }>;
}

export interface SessaoChat {
  id: string; canal: string; estado: string; nome_cliente: string | null; loja_id: string | null; loja: string | null;
  ultima_msg_cliente_em: string | null; ultima_msg_pagali_em: string | null; created_at: string;
  mensagens_recebidas: number; mensagens_enviadas: number; carrinho_estado: string | null; carrinho_total: number | null;
}

export interface EventoChat {
  id: number; tipo: string; direcao: 'IN' | 'OUT' | 'SYS'; msg_id_canal: string | null; conteudo: string | null;
  dados: any; estado_antes: string | null; estado_depois: string | null; erro: string | null; created_at: string;
}

export interface ServicoChat {
  id: string; entidade_id: string; entidade_sisp: string; entidade_nome: string;
  tipo_servico: string; transaction_code: string; rotulo: string;
  ajuda_referencia: string | null; valor_min: number | null; valor_max: number | null;
  devolve_token: boolean; ordem: number; activo: boolean;
  pagos: number; receita_cve: number;
}

export interface EntidadeSisp {
  id: string; nome: string; codigo: string; tipo: string | null; pos: string | null;
  tem_recarga: boolean; tem_factura: boolean;
}

export interface ComercianteChat {
  loja_id: string; nome: string; slug: string | null; produtos_activos: number;
  no_canal: boolean; activo: boolean; recebe_email: string | null; saudacao: string | null; limite_sessao_cve: number | null;
  actualizado_em: string | null;
  link_whatsapp: string | null;
  numero_whatsapp: string | null;
  instancia: string | null;
}

export const chatToPayService = {
  painel: (params: { dias: number; canal?: string }) => api.get<{ success: boolean } & PainelChatToPay>('/admin/chat-to-pay/painel', { params }),
  sessoes: (params: { limit?: number; canal?: string; estado?: string; loja?: string }) => api.get<{ success: boolean; data: SessaoChat[] }>('/admin/chat-to-pay/sessoes', { params }),
  eventos: (id: string) => api.get<{ success: boolean; data: EventoChat[] }>(`/admin/chat-to-pay/sessoes/${id}/eventos`),
  encerrar: (id: string) => api.post(`/admin/chat-to-pay/sessoes/${id}/encerrar`),
  comerciantes: () => api.get<{ success: boolean; data: ComercianteChat[] }>('/admin/chat-to-pay/comerciantes'),
  guardarComerciante: (lojaId: string, body: { activo?: boolean; saudacao?: string | null; limite_sessao_cve?: number | null; recebe_email?: string; numero_whatsapp?: string | null; instancia?: string | null }) =>
    api.put(`/admin/chat-to-pay/comerciantes/${lojaId}`, body),
  entidadesSisp: () => api.get<{ success: boolean; data: EntidadeSisp[] }>('/admin/chat-to-pay/entidades-sisp'),
  criarServico: (body: { entidade_id: string; tipo_servico: 'RCG' | 'FAT'; rotulo?: string; ajuda_referencia?: string; valor_min?: number | null; valor_max?: number | null; devolve_token?: boolean; ordem?: number }) =>
    api.post('/admin/chat-to-pay/servicos', body),
  removerServico: (id: string) => api.delete(`/admin/chat-to-pay/servicos/${id}`),
  servicos: () => api.get<{ success: boolean; data: ServicoChat[] }>('/admin/chat-to-pay/servicos'),
  guardarServico: (id: string, body: { activo?: boolean; rotulo?: string; ajuda_referencia?: string | null; valor_min?: number | null; valor_max?: number | null; ordem?: number }) =>
    api.put(`/admin/chat-to-pay/servicos/${id}`, body),
  instancia: (lojaId: string, comQr = true) => api.get<{ success: boolean; data: { instancia: string | null; estado: string; qr: string | null; numero: string | null; erro?: string } }>(`/admin/chat-to-pay/comerciantes/${lojaId}/instancia`, { params: { qr: comQr ? '1' : '0' } }),
  instanciaWebhook: (lojaId: string, ligado: boolean) => api.post(`/admin/chat-to-pay/comerciantes/${lojaId}/instancia/webhook`, { ligado }),
  instanciaApagar: (lojaId: string) => api.delete(`/admin/chat-to-pay/comerciantes/${lojaId}/instancia`),
  simular: (body: { contacto: string; mensagem: string; classificador?: 'lyra' | 'regras'; nome?: string; loja?: string }) =>
    api.post('/admin/chat-to-pay/simular', body),
};
